import { UrlMappingsKeys } from '../types';
import { paramValidatorError } from './errors';
var keyOptions = Object.values(UrlMappingsKeys);
export var keyValidatorError = paramValidatorError('key', "must be one of: ".concat(keyOptions.toString()));
export var keyValidator = function (key) {
    var typeofKey = typeof key;
    if (typeofKey !== 'string' || !keyOptions.includes(key)) {
        return keyValidatorError;
    }
};
//# sourceMappingURL=key.js.map